export default {
  AvailableCompanies: 'AvailableCompanies',
  PasswordChange: 'Password Change',
  UsersUpdate: 'User Update',
  NewUsersAdd: 'New Users Add',
  UserReamove: 'User Reamove',

  Activate: 'Activate',
  BankCard: 'bank Card',
  Block: 'Block',
  BirthYear: 'Birth Day',
  BirthMonth: 'Birth Month',
  BirthDay: 'Birth Day',
  Email: 'Email',
  EmailConfirmed: 'Email Confirmed',
  EconomicCode: 'Economic Code',
  FirstName: 'First Name',
  ChangePassword: 'Change Password',
  CompanyName: 'Courier Name',
  FatherName: 'Father Name',
  UserName: 'User Name',
  Mobile: 'Mobile',
  MobileConfimed: 'Mobile Confimed',
  Name: 'Name',
  Specifications: 'Specifications',
  ScopeOfAccess: 'Scope Of Access',
  LastName: 'Last Name',
  LimitedUser: 'Limited User',
  Legal: 'Legal',
  UserType: 'User type',

  LegalNationalId: 'Legal NationalId',
  License: 'License',

  issueTime: 'Issue time',
  licenseIssueTime: 'License issue time',
  LicenseExpireTime: 'License expire time',
  LicenseExpireTimeMin: 'License ExpireTime Min',
  LicenseExpireTimeMax: 'License ExpireTime Max',
  LicenseImage: 'License Image',
  LicenseFrontImage: 'License Image - Front',
  LicenseBackImage: 'License Image - Back',
  LicenseNumber: 'License Number',
  LicenseTypeId: 'License TypeId',
  NationalCardBackImage: 'National Card - Back',
  NationalCardFrontImage: 'National Card - Front',
  VehicleCardFrontImage: 'Vehicle Card - Front',
  VehicleCardBackImage: 'Vehicle Card - Back',
  VehicleCardIssueTime: 'License issue time',
  VehicleCardExpireTime: 'License expire time',
  VehicleCardNumber: 'License Number',
  VehicleCard: 'Vehicle Card',
  Gender: 'Gender',
  Male: 'Male',
  Female: 'Female',
  Roles: 'Roles',
  RealUser: 'Real user',
  Neutral: 'Neutral',
  NationalId: 'National Id',
  Person: 'Person',
  Password: 'Password',
  passwordConfirm: 'password Confirm',
  Profile: 'Profile',
  RegistrationNumber: 'Registration Number',
  TesterUser: 'Tester user',
  TrajectoryDateMin: 'Trajectory Date Min',
  TrajectoryDateMax: 'Trajectory Date Max',
  Users: 'Users',
  Unblock: 'Unblock',
  AreYouSureYouWantToUnblockThisUser:
    'Are you sure you want to unblock this user?',
  userUnblockedSuccessfully: 'User unblocked successfully',
  Blocked: 'Blocked',
  LimitedUsers: 'Limited users',
  legalUser: 'Legal user',
  passwordChangedSuccessfully: 'Password changed successfully',
  birthCertificateId: 'Birth certificate id',
  marriageDate: 'Marriage date',
  documents: 'Documents',
  licence: 'Licence',
  smartCard: 'Smart card',
  smartCardNumber: 'Smart card number',
  smartCardIssueTime: 'Smart card issue time',
  smartCardExpireTime: 'Smart card expire time',
  smartCardImageFront: 'Smart card image - front',
  smartCardImageBack: 'Smart card image - back',
  healthCard: 'Health card',
  healthCardNumber: 'Health card number',
  healthCardIssueTime: 'Health card issue time',
  healthCardExpireTime: 'Health card expire time',
  healthCardImageFront: 'Health card image - front',
  healthCardImageBack: 'Health card image - back',
  toAdd_FillingAllInformationOfThisSectionIsNecessary:
    'To add {section}, filling all information of this section is necessary',
  issueDateOf_section_CanNotBeLaterThanExpirationDate:
    'Issue date of {section} can not be later than expiration date',
  issueDateOf_section_CanNotBeSameAsExpirationDate:
    'Issue date of {section} can not be same as expiration date',
  sessions: 'Sessions',
  // refactor
  nationalId: 'National ID',
  gender: 'Gender',
  fatherName: 'Father name',
  birthYear: 'Birth year',
  birthDay: 'Birth day',
  birthMonth: 'Birth month',
  bankCard: 'Bank card',
  person: 'Person',
  companyName: 'Courier name',
  registrationNumber: 'Registration number',
  economicCode: 'Economic code',
  legalNationalId: 'Legal national ID',
  testerUser: 'Tester user',
  licenseNumber: 'License number',
  licenseExpireTime: 'License expire time',
  licenseFrontImage: 'License Image - Front',
  licenseBackImage: 'License Image - Back',
  roles: 'Roles',
  courierLimit: 'Courier limit',
  changeRoles: 'Change roles',
  changeLicense: 'Change role licenses',
  changeAuthorityLimit: 'Change limits',
  userDetail: 'User detail',
  userInformation: 'User information',
  userEdit: 'User edit',
  addressId: 'Address ID',
  userId: 'User ID',
  educationLevelId: 'Education level ID',
  licenseTypeId: 'License type ID',
  changeLimitLicense: 'Change limit license',
  Legal: 'Legal',
  changePassword: 'Change Password',
  unblock: 'Unblock',
  birthYear: 'Birth Day',
  birthMonth: 'Birth Month',
  birthDay: 'Birth Day',
  scopeOfAccess: 'Scope Of Access',
  userType: 'User type',
  mobileConfirmed: 'Mobile Confimed',
  emailConfirmed: 'Email Confirmed',
  blocked: 'Blocked',
  companyUser: 'courier user',
  barbanetUser: 'barbanet user',
  availableCompanies: 'Available couriers',
  neutral: 'Neutral',
  deleted: 'Deleted',
  hasPassword: 'Has Password',
  updateGeneralLimits: 'Update general limits',
  confirmedMobile: 'Confirmed mobile',
  AreYouSureYouWantToConfirmThisMobile:
    'Are you sure you want to confirm this mobile',
  mobileConfirm: 'Mobile confirm',
  mobileConfirmSuccessfully: 'Mobile confirm successfully',
  accounting: 'Accounting',
  firstName: 'FirstName',
  lastName: 'Lastname',
  completeInformation: 'Complete information',
  completeInformationWasSuccessfully: 'Complete information was successfully',
  AreYouSureYouWantToEnableTester: 'Are you sure you want to enable tester',
  AreYouSureYouWantToDisableTester: 'Are you sure you want to disable tester',
  changeTester: 'Change tester',
  userHasBeenDisabledTesterSuccessfully: 'Disable user was successfully',
  userHasBeenEnabledTesterSuccessfully: 'Enable user was successfully',
  changeTwoFactor: 'Change Two factor enable',
  userHasBeenDisabledTwoFactorSuccessfully:
    'Disable Two factor was successfully',
  userHasBeenEnabledTTwoFactorSuccessfully:
    'Enable Two factor was successfully',
  twoFactorEnabled: 'Two factor enabled',
  personalDriver: 'Personal driver',
  vehicleMustBeSelected: 'Vehicle mist be selected',
  suspend: 'Suspend',
  unsuspend: 'Unsuspend',
  AreYouSureYouWantToSuspendThisUser:
    'Are you sure you want to suspend this user',
  AreYouSureYouWantToDeleteThisDriver:
    'Are you sure you want to delete this driver',
  AreYouSureYouWantToUnsuspendThisUser:
    'Are you sure you want to unsuspend this user',
  userUnsuspendSuccessfully: 'User Unsuspend successfully',
  suspendReason: 'Suspend reason',
  suspendReasonDescription: 'Suspend description',
  acceptShipment: 'Accept order',
  acceptOfferSuccessfully: 'Accept offer successfully',
  shipmentOffers: 'Order offers',
  driverCurrentLocation: 'Driver current location',
  addPassword: 'Add password',
  deleteReason: 'Delete reason',
  deleteReasonDescription: 'Delete description',
  driverApproved: 'Driver approved',
  changeLegal: 'Change to legal',
  updateLegal: 'Update legal information',
  legalPhone: 'Legal phone',
  legalCityId: 'Legal city Id',
  userRejectedSuccessfully: 'User rejected successfully',
  userApprovedSuccessfully: 'User approved successfully',
  oldPassword: 'Old password',
  newPassword: 'New password'
}
